<script lang="ts">
	import type { ComponentProps } from 'svelte';
	import PriceRange from '$lib/components/atoms/priceRange/PriceRange.svelte';

	type CardDateObject = {
		startDate: string;
		startDatetime: string;
		endDate: string;
		endDatetime: string;
	};

	interface Props {
		mainContent?: string;
		subContent?: string;
		dates?: CardDateObject;
		priceRange?: ComponentProps<typeof PriceRange>;
	}

	const {
		mainContent,
		subContent,
		dates,
		priceRange,
	}: Props = $props();

	const baseClasses = 'text-xs text-coloredneutral-softest w-full min-w-max';
// TODO: check a way to pass abbr tag to currency, eg: <abbr title="Euro">€</abbr>
</script>

{#if mainContent || subContent || dates || priceRange}
	<div data-testid="poi-card-price-tag" class={['flex flex-wrap px-1 py-0.5 bg-neutral-weakest shadow-smooth-top-3 rd-0.5', priceRange ? 'w-fit' : 'w-min']}>
		{#if priceRange}
			<PriceRange {...priceRange} />
		{:else if mainContent}
			<div class="text-md text-coloredneutral font-400 w-full whitespace-nowrap">
				{mainContent}
			</div>
		{/if}

		{#if subContent}
			<div class={baseClasses}>{subContent}</div>
		{/if}

		{#if dates}
			<span class={['flex flex-nowrap', baseClasses]}>
				<time datetime={dates.startDatetime}>{dates.startDate}</time> - <time datetime={dates.endDatetime}>{dates.endDate}</time>
			</span>
		{/if}
	</div>
{/if}
